import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import manifest from "@frog/source/manifest.js"

import Frame from "@frog/source/views/app/components/Frame.view.js"
import MiniMenu from "@frog/source/views/app/components/MiniMenu.view.js"

import CombatEncounterScreen from "@frog/source/views/app/screens/CombatEncounterScreen.view.js"
import SplashScreen from "@frog/source/views/app/screens/SplashScreen.view.js"
import OverworldScreen from "@frog/source/views/app/screens/OverworldScreen.view.js"
import ErrorScreen from "@frog/source/views/app/screens/ErrorScreen.view.js"
import CreditsScreen from "@frog/source/views/app/screens/CreditsScreen.view.js"
const screens = {
    SplashScreen,
    "EncounterScreen": CombatEncounterScreen,
    OverworldScreen,
    ErrorScreen,
    CreditsScreen,
    // TODO: Load these dynamically
}

import "@frog/source/views/app/App.view.less"

export default class AppView {
    render() {
        return
        return (
            <div class="App">
                <title>{this.title}</title>
                <Frame>
                    <div class="Transition" isTransitioning={Navigation.state.isTransitioning == true}/>
                    {this.content}
                    <MiniMenu/>
                </Frame>
            </div>
        )
    }
    get title() {
        return manifest["name"] // + " - " + Navigation.state.screen
    }
    get content() {
        const Screen = screens[Navigation.state.screen]
        return <Screen/>
    }
}
